<div class="table-container">
  <table class="table" style="border-collapse: separate; border-spacing: 0">
    <thead>
      <tr>
        <th></th>
        <!-- Column for the icon open sub group -->
        <th *ngIf="showButtonRow"></th>
        <th *ngIf="showSecondButtonRow"></th>
        <th *ngFor="let column of columns">{{ column.header }}</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let row of data">
        <!-- Main row -->
        <tr [class.expanded]="row === expandedRow">
          <td
            (click)="onRowClick(row)"
            [class.row-selected]="row === expandedRow"
            class="icon-cell cursor-pointer"
          >
            <i
              *ngIf="expandedRow === row && subRowName !== null && row[subRowName].length !== 0"
              class="icon-minus"
            >
              [-]
            </i>
            <i
              *ngIf="expandedRow !== row && subRowName !== null && row[subRowName].length !== 0"
              class="icon-plus"
            >
              [+]
            </i>
          </td>
          <td
            (click)="buttonClickRow(row)"
            *ngIf="showButtonRow"
            [class.row-selected]="row === expandedRow"
            class="icon-cell"
          >
            <span
              *ngIf="subRowName !== null && row[subRowName].length !== 0"
              class="bg-green-600 py-1 px-2 rounded-lg text-white cursor-pointer"
            >
              <fa-icon [icon]="icon"></fa-icon>
            </span>
          </td>
          <td
            (click)="secondButtonClickRow(row)"
            *ngIf="showSecondButtonRow"
            [class.row-selected]="row === expandedRow"
            class="icon-cell"
          >
            <span
              *ngIf="subRowName !== null && row[subRowName].length !== 0"
              class="bg-blue-500 py-1 px-2 rounded-lg text-white cursor-pointer"
            >
              <fa-icon [icon]="faReceipt"></fa-icon>
            </span>
          </td>
          <td *ngFor="let column of columns" [class.row-selected]="row === expandedRow">
            {{ formatValue(row[column.field], column.type) }}
          </td>
        </tr>
        <!-- Sub rows for the expanded main row -->
        <tr *ngIf="row === expandedRow && subRowName !== null && row[subRowName].length !== 0">
          <td [attr.colspan]="columns.length + 1">
            <!-- Adjust colspan to include the icon column -->
            <table class="nested-table">
              <thead>
                <tr>
                  <th *ngFor="let subColumn of subColumns">{{ subColumn.header }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let subRow of row.movimenti">
                  <td *ngFor="let subColumn of subColumns">
                    {{ formatValue(subRow[subColumn.field], subColumn.type) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </ng-container>
    </tbody>
    <tfoot>
      <tr>
        <th></th>
        <!-- Empty cell for the icon open sub group -->
        <th *ngIf="showButtonRow"></th>
        <th *ngIf="showSecondButtonRow"></th>
        <th *ngFor="let column of columns">
          <span
            *ngIf="showSumCounter && columnSums[column.field] !== undefined"
            class="text-lg text-white"
          >
            {{ formatValue(columnSums[column.field], column.type) }}
          </span>
        </th>
      </tr>
    </tfoot>
  </table>
</div>
